import { render, staticRenderFns } from "./crumb.vue?vue&type=template&id=33c18688&scoped=true&"
import script from "./crumb.vue?vue&type=script&lang=js&"
export * from "./crumb.vue?vue&type=script&lang=js&"
import style0 from "./crumb.vue?vue&type=style&index=0&id=33c18688&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c18688",
  null
  
)

export default component.exports